// Smoothly scroll to an element id using the global Lenis instance (fallback to native)
export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -10, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_dda150cc-0e0f-47cb-ac5b-c75778b571cf/artifacts/zfxjuyh3_CODE%20ECHO%20LOGO.png";
